import React from 'react';
import { Link } from 'react-router-dom';

const InnerHeaderContent = (props) => {

    return (
        <div className='header-inner'>
            <div className='container'>
                <div className='row'>
                    <div className='col-lg-12 mt-4 text-center'>
                        <span className=' mb-5 brdr-btm-pink f-mon-semibold f-66 mt-cus-header-full'>{props.pageName}</span>
                        {/* <div className='border-btm-header-top-pink'>
                        </div> */}
                        <div className='bg-pink-header-buy'>
                            <div className='row'>
                                <div className='col-lg-6 text-left'>
                                    <p className='f-mon-reg f-18 mb-3 txt-captl mt-3'>Get in the game with a complimentary </p>
                                    <p className='f-mon-bold f-35 lh-0 txt-captl'>Bet of The Day</p>
                                </div>
                                <div className='col-lg-6'>
                                    <p className='f-mon-reg f-16 mb-2 twnty-res txt-captl'>Check out my custom packages for your ease.</p>
                                    {/* <button className='btn btn-light f-mon-reg f-16 bt-header-other'>
                                        BROWSE OUR PACKAGES
                                    </button> */}
                                    <Link to="/packages" className='btn btn-light f-mon-reg f-16 bt-header-other twnty-res'>
                                        BROWSE OUR PACKAGES
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default InnerHeaderContent;